import { lazy, Suspense, useEffect, useState, type ReactElement } from 'react';
import { useStoreLocator } from '../../providers/store-locator';

const StoreLocatorSheet = lazy(() => import('@/extensions/store-locator/components/header/store-locator-sheet'));

/**
 * Headless host that mounts the store locator sheet when opened from PDP,
 * checkout, or other flows. No header trigger — the sheet is opened via
 * `useStoreLocator().open()`.
 */
export default function StoreLocatorSheetHost(): ReactElement | null {
    const [mounted, setMounted] = useState(false);
    const isOpen = useStoreLocator((state) => state.isOpen);
    const openStoreLocator = useStoreLocator((state) => state.open);
    const closeStoreLocator = useStoreLocator((state) => state.close);

    useEffect(() => {
        if (isOpen) {
            setMounted(true);
            return;
        }
        setMounted(false);
    }, [isOpen]);

    if (!mounted) {
        return null;
    }

    const handleOpenChange = (open: boolean) => {
        if (open) {
            openStoreLocator();
            return;
        }
        closeStoreLocator();
    };

    return (
        <Suspense fallback={null}>
            <StoreLocatorSheet open={isOpen} onOpenChange={handleOpenChange} />
        </Suspense>
    );
}
